import { Stack, Typography, useTheme } from "@mui/material";
import { CheckCircle2, Circle } from "lucide-react";
import type { FC } from "react";
import type { GetTaskWorkflowStepResponse } from "web_myplann/Infrastructure/Api/Api";
import {
	dateFormatter,
	SHORT_DATE_FORMAT,
} from "web_myplann/Shared/Utils/dateFormatters";
import { TaskStepConnector } from "web_myplann/Tasks/Components/TaskStepConnector";

type Props = {
	data: GetTaskWorkflowStepResponse;
	isFirst: boolean;
	isLast: boolean;
};

export const TaskSubtaskRow: FC<Props> = ({ data, isFirst, isLast }) => {
	const { palette, iconSize, spacingTokens, activity } = useTheme();
	const { rowMinHeight, railWidth, contentPaddingY, iconStrokeWidth } =
		activity.stepTimeline;
	const { isCompleted, name, completedDate, dueDate } = data;

	const formattedDate = dateFormatter(
		isCompleted ? completedDate : dueDate,
		SHORT_DATE_FORMAT,
	);

	return (
		<Stack
			direction="row"
			gap={spacingTokens.md}
			px={spacingTokens.lg}
			minHeight={rowMinHeight}
		>
			<Stack
				width={railWidth}
				flexShrink={0}
				alignItems="center"
				gap={spacingTokens.xs}
			>
				<TaskStepConnector visible={!isFirst} />
				{isCompleted ? (
					<CheckCircle2
						size={iconSize.md}
						color={palette.green[500]}
						fill={palette.green[50]}
						strokeWidth={iconStrokeWidth}
						style={{ flexShrink: 0 }}
					/>
				) : (
					<Circle
						size={iconSize.md}
						color={palette.grey[400]}
						fill={palette.grey[50]}
						strokeWidth={iconStrokeWidth}
						style={{ flexShrink: 0 }}
					/>
				)}
				<TaskStepConnector visible={!isLast} />
			</Stack>
			<Stack
				flex={1}
				minWidth={0}
				justifyContent="center"
				gap={spacingTokens.xxs}
				py={contentPaddingY}
			>
				<Typography
					variant="bodyMedium"
					color={isCompleted ? palette.grey[500] : palette.grey[900]}
				>
					{name}
				</Typography>
				{formattedDate && (
					<Typography variant="hint">{formattedDate}</Typography>
				)}
			</Stack>
		</Stack>
	);
};
